<template>
  <div class="simple-pagination d-flex justify-content-center">
    <a v-if="prev.link" class="simple-pagination__prev pagination_btn" :href="prev.link">
      {{ prev.title }}
    </a>
    <a class="simple-pagination__between pagination_btn" :href="between.link">
      {{ between.title }}
    </a>
    <a v-if="next.link" class="simple-pagination__next pagination_btn" :href="next.link">
      {{ next.title }}
    </a>
  </div>
</template>

<script>

export default {
  props: {
    prev: {
      title: String,
      link: String,
    },
    between: {
      title: String,
      link: String,
      required: true,
    },
    next: {
      title: String,
      link: String,
    },
  },
}
</script>